import { FirebaseError } from "firebase/app"

export const translateFirebaseError = (error: unknown): Error => {
   if (error instanceof FirebaseError) {
      switch (error.code) {
         case "auth/invalid-credential":
            return new Error("Identifiants invalides. Veuillez réessayer.")
         case "auth/user-not-found":
            return new Error("Aucun utilisateur trouvé avec ces identifiants.")
         case "auth/wrong-password":
            return new Error("Mot de passe incorrect.")
         case "auth/email-already-in-use":
            return new Error("Cet email est déjà utilisé.")
         case "auth/weak-password":
            return new Error("Le mot de passe est trop faible.")
         case "auth/too-many-requests":
            return new Error("Trop de tentatives. Veuillez réessayer plus tard.")
         case "auth/user-disabled":
            return new Error("Votre compte est désactivé. Veuillez contacter un administrateur.")
         case "auth/invalid-action-code":
            return new Error("Le lien de réinitialisation du mot de passe n'est plus valable.")
         default:
            return new Error(error.message || "Une erreur Firebase est survenue.")
      }
   }

   return error instanceof Error ? error : new Error("Une erreur inconnue est survenue.")
}
